module.exports = __webpack_public_path__ + "img/tuf16.43862b51.jpg";